import React, { Fragment, useMemo } from "react";
import { useFormikContext } from "formik";
import get from "lodash/get";
import MenuNavHeader from "components/MenuNavHeader";
import { FIELD_TYPES } from "utils/constants/form";
import SelectField from "./Select";
import MultiselectField from "./Multiselect";
import InputField from "./Input";
import TextareaField from "./Textarea";
import PhoneField from "./Phone";
import ToggleField from "./Toggle";
import CheckboxField from "./Checkbox";
import DisclaimerField from "./Disclaimer";
import DatepickerField from "./Datepicker";
import TinField from "./Tin";
import FileField from "./File";
import IdentityField from "./Identity";
import AddressField from "./Address";
import LegalField from "./Legal";
import { STATE_KEYS } from "utils/constants/state";
import { FIELD_GROUP_INTENT } from "utils/constants/fields";
import HoverIconButton from "components/HoverIconButton";
import ConfirmIconButton from "components/ConfirmIconButton";
import { SMALL_ICON_SIZE } from "utils/constants/ui";
import { removeManifestFormField } from "utils/manifest";
import { FIELD_REMOVAL, getFieldRemovalSlides } from "utils/constants/confirm";
import { useFirstComboFromFields } from "utils/hooks/manifest";

const FIELD_COMPONENTS = {
  // Standard
  [FIELD_TYPES.SELECT]: SelectField,
  [FIELD_TYPES.MULTISELECT]: MultiselectField,
  [FIELD_TYPES.INPUT]: InputField,
  [FIELD_TYPES.TEXTAREA]: TextareaField,
  [FIELD_TYPES.TOGGLE]: ToggleField,
  [FIELD_TYPES.CHECKBOX]: CheckboxField,
  [FIELD_TYPES.DISCLAIMER]: DisclaimerField,
  [FIELD_TYPES.DATEPICKER]: DatepickerField,
  // Specialized
  [FIELD_TYPES.TIN]: TinField,
  [FIELD_TYPES.FILE]: FileField,
  [FIELD_TYPES.IDENTITY]: IdentityField,
  [FIELD_TYPES.PHONE]: PhoneField,
  [FIELD_TYPES.ADDRESS]: AddressField,
  [FIELD_TYPES.LEGAL]: LegalField
};

const FieldShow = ({ name, headerProps }) => {
  const {
    values,
    touched,
    setTouched,
    setValues,
    setFieldValue
  } = useFormikContext();
  const field = get(values, name);
  const combo = useFirstComboFromFields([field]);

  const fieldUID = field.uid;

  const FieldComponent = FIELD_COMPONENTS[fieldUID];

  const actions = (
    <div className="flex flex-row">
      <div className="pr2 mr2 dib br hairline-1">
        <ConfirmIconButton
          icon="delete"
          tooltip={FIELD_REMOVAL[0] && FIELD_REMOVAL[0].title}
          slides={getFieldRemovalSlides(combo)}
          size={SMALL_ICON_SIZE}
          onConfirm={() => {
            removeManifestFormField({
              values,
              touched,
              setValues,
              setTouched,
              name
            });
          }}
        />
      </div>
      <HoverIconButton
        size={SMALL_ICON_SIZE}
        type="add"
        tooltip="Add field"
        onClick={() => {
          setFieldValue(
            STATE_KEYS.EDITOR.MENU_SUB_INTENT,
            FIELD_GROUP_INTENT.ADD_FIELD
          );
        }}
      />
    </div>
  );

  return (
    <Fragment>
      <MenuNavHeader buttonProps={headerProps} label={field.label}>
        {actions}
      </MenuNavHeader>
      <div className="fieldShow--fieldComponent w-100 pt3">
        {FieldComponent && <FieldComponent name={name} />}
      </div>
    </Fragment>
  );
};

export default FieldShow;
